import { render, staticRenderFns } from "./JourneyBuilderOverview.vue?vue&type=template&id=0fa54306&scoped=true&"
import script from "./JourneyBuilderOverview.vue?vue&type=script&lang=js&"
export * from "./JourneyBuilderOverview.vue?vue&type=script&lang=js&"
import style0 from "./JourneyBuilderOverview.vue?vue&type=style&index=0&id=0fa54306&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa54306",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fa54306')) {
      api.createRecord('0fa54306', component.options)
    } else {
      api.reload('0fa54306', component.options)
    }
    module.hot.accept("./JourneyBuilderOverview.vue?vue&type=template&id=0fa54306&scoped=true&", function () {
      api.rerender('0fa54306', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Overview/JourneyBuilderOverview.vue"
export default component.exports